import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Female(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M12 4a3 3 0 00-2.99 2.753c1.203-.123 2.966-.709 4.344-2.43A2.988 2.988 0 0012 4zm0 6a3 3 0 01-2.736-1.767c1.533-.18 3.6-.927 5.218-2.919A3 3 0 0112 10zM7 7a5 5 0 1110 0A5 5 0 017 7zm.88 9.818A3 3 0 0110.638 15h2.724a3 3 0 012.758 1.818l1.96 4.576a1 1 0 101.84-.788l-1.962-4.576A5 5 0 0013.362 13h-2.724a5 5 0 00-4.596 3.03L4.08 20.606a1 1 0 101.838.788l1.961-4.576z",
    clipRule: "evenodd"
  }));
}

export default Female;